import { create } from "zustand";

export const useOrdersStore = create((set) => ({
  orders: {},
  orderDetail: null,
  orderCountStatusAllTime: {},
  orderNotes: {},
  cancelOrder: {},
  refundOrder: {},
  setOrders: (orders) => set({ orders }),
  setOrderDetail: (orderDetail) => set({ orderDetail }),
  setOrderNotes: (orderNotes) => set({ orderNotes }),
  setOrderCountStatusAllTime: (orderCountStatusAllTime) => set({ orderCountStatusAllTime }),
  setOrderCountStatusMonth: (orderCountStatusAllTime) => set({ orderCountStatusAllTime }),
  setCancelOrderProduct: (cancelOrder) => set({ cancelOrder }),
  setRefundOrderProduct: (refundOrder) => set({ refundOrder }),
}));
